import { Injectable } from '@angular/core'
import {
  AddInvoiceDialogComponent,
  CreateInvoiceParams,
} from '@tv3/containers/invoices/invoices/add-invoice/add-invoice-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { MatDialogConfig } from '@angular/material/dialog'
import { SelectInquiryDialogService } from '@tv3/shared/dialogs/select-inquiry-dialog/select-inquiry-dialog.service'
import { InvoiceTypes } from '@tokeet-frontend/invoices'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { switchMap } from 'rxjs/operators'

@Injectable()
export class AddInvoiceDialogService {
  constructor(private dialog: DialogService, private selectInuqiryDialog: SelectInquiryDialogService) {}

  public open(data: CreateInvoiceParams) {
    const defaultConfig: MatDialogConfig = {
      data: { ...data },
      panelClass: ['drawer-full-90'],
    }

    const dialogRef = this.dialog.openDrawer(AddInvoiceDialogComponent, defaultConfig)

    return dialogRef
  }

  addInvoice(type = InvoiceTypes.BookingInvoice) {
    return this.selectInuqiryDialog
      .open()
      .pipe(switchMap((item: Inquiry) => this.open({ type, inquiryId: item.id }).afterClosed()))
  }
}
